<template>
  <div>
    <div class="dashboard">
      Warehouse
    </div>
  </div>
</template>

<script>
export default {
  name: "WarehousePage",
  data() {
    return {
      publicPath: process.env.VUE_APP_IMG_BASE_URL
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logOut");
      this.$router.push("/");
    }
  }
};
</script>
